import { Component, Input, OnInit, Output } from '@angular/core';
import {
  ShoppingProducts,
  WarrantyOption,
} from '../interfaces/ShoppingProductsItem';
import { EventEmitter } from 'stream';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { ShoppingCartService } from '../shoppingCart.service';

@Component({
  selector: 'app-warrenty-options',
  templateUrl: './warrenty-options.component.html',
  styleUrls: ['./warrenty-options.component.less'],
})
export class WarrentyOptionsComponent implements OnInit {
  @Input() product: ShoppingProducts;
  @Input() cardCode: string;
  @Input() shipToCode: string;
  options: WarrantyOption[] = [];
  selectedIndex: number | null = null;
  selectedWarranty: WarrantyOption;
  constructor(
    private sCartService: ShoppingCartService,
    private drawerRef: NzDrawerRef
  ) {}

  private readonly NO_WARRANTY: WarrantyOption = {
    Code: '',
    Label: 'Standard Manufacturer Warranty (1 Year) – Included',
    //Quantity: 1,
    Price: 0,
    TaxRate: 0,
    //Total: 0,
  };

  ngOnInit(): void {
    //alert(this.product.ItemCode);
    const parsed = this.parseOptions(this.product?.WarrentyOptions);
    parsed.forEach((element) => {
      if (
        element.Code == null ||
        element.Code === undefined ||
        element.Code === ''
      ) {
        element.Price = 0;
        //element.Quantity = 1;
        element.TaxRate = 0;
        //element.Total = 0;
      }
      this.sCartService
        .GetItemTaxRate(this.cardCode, element.Code, this.shipToCode)
        .subscribe((data: any) => {
          console.log(data.Rate);
          element.TaxRate = data.Rate;
        });
    });
    //this.options = [this.NO_WARRANTY, ...parsed];
    this.options = [...parsed];
  }

  select(index: number): void {
    this.selectedIndex = index;
    this.selectedWarranty = this.options[index] ?? null;

    /*this.sCartService
      .GetItemTaxRate(
        this.cardCode,
        this.selectedWarranty.Code,
        this.shipToCode
      )
      .subscribe((data: any) => {
        console.log(data.Rate);
        this.selectedWarranty.TaxRate = data.Rate;
      });*/
  }

  submit(): void {
    this.selectedWarranty =
      this.selectedIndex !== null ? this.options[this.selectedIndex] : null;

    if (this.selectedWarranty.Label === 'No warranty') {
      this.selectedWarranty = undefined;
    }

    this.drawerRef.close();
  }

  private parseOptions(
    raw: ShoppingProducts['WarrentyOptions']
  ): WarrantyOption[] {
    if (!raw) return [];

    // Already parsed
    if (Array.isArray(raw)) {
      return this.sanitizeArray(raw);
    }

    // Try to parse JSON string (API provides escaped quotes)
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return this.sanitizeArray(parsed);
      }
    } catch (e) {
      // Last resort: try to unescape once and parse again
      try {
        const unescaped = raw.replace(/\\\"/g, '"');
        const parsed = JSON.parse(unescaped);
        if (Array.isArray(parsed)) {
          return this.sanitizeArray(parsed);
        }
      } catch {}
    }

    return [];
  }

  private sanitizeArray(arr: any[]): WarrantyOption[] {
    return arr
      .filter(
        (x) =>
          x &&
          typeof x.Code === 'string' &&
          typeof x.Label === 'string' &&
          typeof x.Price === 'number'
      )
      .map((x) => ({
        Code: String(x.Code),
        Label: String(x.Label),
        Quantity: Number(x.Quantity),
        Price: Number(x.Price),
        TaxRate: Number(x.TaxRate),
        Total: Number(x.Total),
      }))
      .filter((x) => x.Label.trim().length > 0 && !Number.isNaN(x.Price));
  }
}
